import i18n from '@/i18n'

const rules = {
  required: value => !!value || i18n.t('Rules.Required'),
  min3: value => (!value.length || value.length >= 3) || i18n.t('Rules.Min') + i18n.tc('Rules.Characters', 3),
  min8: value => (!value.length || value.length >= 8) || i18n.t('Rules.Min') + i18n.tc('Rules.Characters', 8),
  min32: value => value.length >= 32 || i18n.t('Rules.Min') + i18n.tc('Rules.Characters', 32),
  max32: value => value.length <= 32 || i18n.t('Rules.Max') + i18n.tc('Rules.Characters', 32),
  inum: value => (!value.length || /^\d{11}$/.test(value)) || i18n.tc('Rules.Digits', 11),
  email: value => {
    const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    return pattern.test(value) || i18n.t('Rules.InvalidEmail')
  }
}

export default {
  install: function (Vue) {
    Vue.$rules = rules
    Object.defineProperties(Vue.prototype, {
      $rules: {
        get: () => rules
      }
    })
  }
}
